package xim.poc.browser

import kotlinx.browser.window
import xim.poc.gl.GpuTimer

class JsViewExecutor(val jsWindow: JsWindow) : ViewExecutor {

    private var lastTimestamp: Double = 0.0
    private var accumulated = 0.0

    private val screenSettings = LocalStorage.getConfiguration().screenSettings

    override fun beginDrawing(loopFunction: (t: Double) -> Unit) {
        loop(loopFunction,0.0)
    }

    private fun loop(loopFunction: (t: Double) -> Unit, timestamp: Double) {
        val elapsed = timestamp - lastTimestamp
        lastTimestamp = timestamp

        if (screenSettings.fpsLimitEnabled) {
            maybeAdmitFrame(loopFunction, elapsed)
        } else {
            executeFrame(loopFunction, elapsed)
        }

        window.requestAnimationFrame { loop(loopFunction, it) }
    }

    private fun maybeAdmitFrame(loopFunction: (t: Double) -> Unit, elapsed: Double) {
        accumulated += elapsed

        val throttle = 1000.0 / screenSettings.fpsLimit.coerceIn(15, 240)
        if (accumulated < throttle) { return }

        executeFrame(loopFunction, accumulated)
        accumulated = 0.0
    }

    private fun executeFrame(loopFunction: (t: Double) -> Unit, elapsed: Double) {
        GpuTimer.report()

        GpuTimer.start()
        jsWindow.clear()

        try {
            loopFunction.invoke(elapsed)
        } catch (t: Throwable) {
            ErrorElement.show("The engine crashed!\n\n" + t.stackTraceToString())
            throw t
        }

        jsWindow.flush()

        GpuTimer.end()
    }

}